
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/best-ai-auto-apply-tools",
      function () {
        return require("private-next-pages/best-ai-auto-apply-tools/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/best-ai-auto-apply-tools"])
      });
    }
  